import { gql } from '@apollo/client';

export const ADYEN_CREATE_PAYMENT = gql`
  mutation AdyenCreatePayment($input: AdyenCreatePaymentInput!) {
    adyenCreatePayment(input: $input) {
      resultCode
      action
      refusalReasonCategory
    }
  }
`;
